/*
Выводит кнопку фильтра
*/

export default {
  name: 'MapFilterButtonComponent',
  props: ['active'],
  template: `
    <button class="partners-map-filter-button" :class="{'partners-map-filter-button--active': active}">
      <img src="/local/templates/new_site_v2/images/parthners_map/filter-new.svg" alt="filter">
    </button>
  `,
}
